export const ExternalLinks = {
  twitter: '',
  documentations: '',
  codes: '',
  medium: '',
  telegram: '',
  discord: '',
};
